// LCG - custom addon script
subscribe(PUB_SUB_EVENTS.cartUpdate, async ({ cartData }) => {
  if (!cartData || !cartData.items) return;

  const mainVariantIds = new Set(
    cartData.items.map(item => String(item.variant_id))
  );

  const orphanAddons = cartData.items.filter(item =>
    item.properties &&
    item.properties._addon_for &&
    !mainVariantIds.has(String(item.properties._addon_for))
  );

  if (!orphanAddons.length) return;

  const updates = {};
  orphanAddons.forEach(item => {
    updates[item.key] = 0;
  });

  await fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ updates })
  });

  document.dispatchEvent(new CustomEvent('cart:refresh'));
});
